<script lang="ts">
	import type { OpenableOption } from "./OpenableOption.js";
	import Drawer from "../Drawer/Drawer.svelte";
	import Button from "../Button.svelte";
	import Modal from "../Modal.svelte";

	export let openedOption: OpenableOption | undefined = undefined;
	export let productOption: OpenableOption;
	export let removeChanges: () => void;

	let showCloseModal = false;
	let onlyHideDrawer = false;

	function onContinue(): void {
		showCloseModal = false;
	}

	function onCancel(): void {
		if (!onlyHideDrawer) {
			removeChanges();
		}
		openedOption = undefined;
		showCloseModal = false;
	}

	function hideDrawer(): boolean {
		onlyHideDrawer = true;
		showCloseModal = true;
		return false;
	}
	function closeDrawer(): boolean {
		onlyHideDrawer = false;
		showCloseModal = true;
		return false;
	}
</script>

<Modal bind:show={showCloseModal} class="max-w-[27.5rem] !p-4 sm:!p-8">
	<div class="text-center">
		<span
			>{onlyHideDrawer
				? "Zavřením panelu přijdete o všechny nové úpravy."
				: "Opravdu si přejete zrušit dosavadní úpravy ?"}</span
		>
	</div>

	<div slot="actions" class="flex flex-wrap items-center justify-between gap-2 sm:gap-0">
		<Button class="border-0" variant="secondary" on:click={onCancel}
			>{onlyHideDrawer ? "Zavřít panel" : "Zrušit úpravy"}</Button
		>
		<Button variant="secondary" on:click={onContinue}>Pokračovat v úpravách</Button>
	</div>
</Modal>

<Drawer
	noBackdrop
	position="right"
	class="w-full transition-all duration-300 ease-out sm:w-[32rem]"
	isOpen={openedOption === productOption}
	showHideButton
	closeButtonMessage="Zrušit úpravy"
	onClose={closeDrawer}
	onHide={hideDrawer}
>
	<slot isShown={openedOption === productOption} />
</Drawer>
